export namespace ColorsUtils {
    export function random(patterns?: Array<string>): string {
        return patterns ? patterns[Math.floor(Math.random() * (patterns.length - 1)) + 1]! : '#' + Math.floor(Math.random() * 16777215).toString(16)
    }
}